export default __webpack_public_path__ + "static/image-fylo-dark-landing-page-8371d393501133917b4aa2b134ce58bb.png";